import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-jc-center" }, "Nessun risultato", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "p-text-right" }
const _hoisted_4 = { class: "p-d-flex p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_CurrencyText = _resolveComponent("CurrencyText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    lazy: true,
    loading: _ctx.isLoading,
    value: _ctx.value,
    rows: 10,
    paginator: true,
    "rows-per-page-options": [10, 20, 50, 100],
    totalRecords: _ctx.totalRecords,
    stripedRows: "",
    responsiveLayout: "scroll",
    onPage: _ctx.onPage
  }, {
    empty: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        header: "Nome",
        field: "business_name"
      }, {
        body: _withCtx(({data}) => [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(data.business_name), 1)
          ]),
          (data.name || data.surname)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(data.name) + " " + _toDisplayString(data.surname), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        header: "N° Ordini",
        field: "orders_count"
      }),
      _createVNode(_component_Column, {
        header: "Totale",
        field: "total_amount",
        headerClass: "column-header-right",
        style: {"max-width":"6rem"}
      }, {
        body: _withCtx(({ data: { total_amount } }) => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_CurrencyText, { modelValue: total_amount }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }),
      (_ctx.displayZoneColumn)
        ? (_openBlock(), _createBlock(_component_Column, {
            key: 0,
            header: "Città",
            field: "zone_name"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Column, null, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: _ctx.getRoute(data)
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_Button, {
                  icon: "pi pi-briefcase",
                  class: "p-button-info"
                }, null, 512), [
                  [
                    _directive_tooltip,
                    'Procedi con questo record',
                    void 0,
                    { left: true }
                  ]
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["loading", "value", "totalRecords", "onPage"]))
}